import { takeLatest } from 'redux-saga/effects';

import * as acaActions from '../action';

import {
    createAnswerSaga,
    deleteAnswerSaga,
    fetchAnswerListSaga,
    fetchQuestionnaireInfoSaga,
    fetchQuestionnaireStatusSaga,
    fetchQuestionsSaga,
    setQuestionnaireStatusSaga,
    updateAnswerSaga,
    updateQuestionnaireStatusSaga,
    fetchAllAnswersSaga,
    fetchQuestionnaireEligibilitySaga,
    fetchBrokerDetailsSaga,
    createConsentSaga,
    fetchConsentDetailsSaga,
    fetchCompanyAdditionalDataSaga,
} from './acaReporting';

/**
 * The root `acaReportingSaga` saga.
 * We're triggering sagas based on their respective events.
 *
 * @method authSaga
 * @type   {Generator}
 */
function* acaReportingSaga() {
    yield takeLatest(acaActions.fetchQuestionnaireInfo.TRIGGER, fetchQuestionnaireInfoSaga);
    yield takeLatest(acaActions.fetchQuestionnaireStatus.TRIGGER, fetchQuestionnaireStatusSaga);
    yield takeLatest(acaActions.fetchQuestions.TRIGGER, fetchQuestionsSaga);
    yield takeLatest(acaActions.setQuestionnaireStatus.TRIGGER, setQuestionnaireStatusSaga);
    yield takeLatest(acaActions.fetchAnswerList.TRIGGER, fetchAnswerListSaga);
    yield takeLatest(acaActions.createAnswer.TRIGGER, createAnswerSaga);
    yield takeLatest(acaActions.updateAnswer.TRIGGER, updateAnswerSaga);
    yield takeLatest(acaActions.deleteAnswer.TRIGGER, deleteAnswerSaga);
    yield takeLatest(acaActions.updateQuestionnaireStatus.TRIGGER, updateQuestionnaireStatusSaga);
    yield takeLatest(acaActions.fetchAllAnswers.TRIGGER, fetchAllAnswersSaga);
    yield takeLatest(
        acaActions.fetchQuestionnaireEligibility.TRIGGER,
        fetchQuestionnaireEligibilitySaga
    );
    yield takeLatest(acaActions.fetchBrokerDetails.TRIGGER, fetchBrokerDetailsSaga);
    yield takeLatest(acaActions.createConsent.TRIGGER, createConsentSaga);
    yield takeLatest(acaActions.fetchConsentDetails.TRIGGER, fetchConsentDetailsSaga);
    yield takeLatest(acaActions.fetchCompanyAdditionalData.TRIGGER, fetchCompanyAdditionalDataSaga);
}

// Default export is the module's root saga.
export default acaReportingSaga;

// Named exports are all the internal sagas that can be used
// for testing as well as imports in other modules
export {
    fetchQuestionnaireInfoSaga,
    fetchQuestionnaireStatusSaga,
    fetchQuestionsSaga,
    setQuestionnaireStatusSaga,
    fetchAnswerListSaga,
    createAnswerSaga,
    updateAnswerSaga,
    deleteAnswerSaga,
    updateQuestionnaireStatusSaga,
    fetchAllAnswersSaga,
    fetchQuestionnaireEligibilitySaga,
    fetchBrokerDetailsSaga,
    createConsentSaga,
    fetchConsentDetailsSaga,
    fetchCompanyAdditionalDataSaga,
};
